import { Link } from "react-router-dom";
import styled, { css } from "styled-components/macro";
import tw from "twin.macro";
import { media } from "../../../styles/global-style";
import {
  backDropFilter,
  whiteAlpha25,
  whiteAlpha40,
} from "../../../styles/style-guide";
import { ContainerUtils } from "../../utils/styles/Utils";

export const Humberger = styled.span`
  ${tw`h-0.5 w-6 bg-primaryClr relative`};

  &:before,
  &:after {
    content: "";
    ${tw`absolute top-0 w-full h-full bg-primaryClr transition-all duration-300 ease-in`};
  }

  &:before {
    left: 0;
    transform: translateY(-8px);
  }

  &:after {
    right: 0;
    transform: translateY(8px);
  }

  transition: background-color 0.3s ease;
`;

export const Toggler = styled.button`
  border: none;
  ${tw`w-12 h-12 cursor-pointer rounded-half bg-white25 border border-solid border-white40 flex items-center justify-center 
    my-0 mx-3 z-10
  `};
`;

export const Inner = styled.div`
  min-height: calc(100vh - 110px);
  max-width: 1200px;
  margin: auto;
  background-color: ${whiteAlpha25};
  border: 1px solid ${whiteAlpha40};
  backdrop-filter: ${backDropFilter};
  padding: 50px 0;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.5s ease;
`;

export const Nav = styled.nav`
  ${tw`fixed left-0 top-0 h-full w-full overflow-y-auto`};
  padding: 50px 15px;
`;

export const List = styled.ul``;

export const Item = styled.li`
  ${tw`text-center`};
`;

export const Page = styled(Link)`
  ${tw`no-underline text-4xl capitalize text-blueDarkClr block font-medium py-2 px-4 relative`};
  transition: color 0.3s ease;

  &:before {
    content: "";
    z-index: -1;
    transition: width 0.5s ease;
    ${tw`absolute right-0 bottom-0 h-1/2 w-0 bg-white25 `}
  }

  &:hover {
    ${tw`text-primaryClr`}
    ::before {
      width: 100%;
    }
  }

  ${media.phone} {
    ${tw`text-3xl`}
  }
`;

export const Container = styled.header<{ hiddenNav: boolean }>`
  ${tw`absolute left-0 top-0 w-full z-10 p-0 pt-6 `};

  ${Nav} {
    ${({ hiddenNav }) =>
      hiddenNav ? "visibility: hidden;" : "visibility: visible;"}
  }

  ${({ hiddenNav }) =>
    !hiddenNav &&
    `
    ${Inner} {
      opacity: 1;
    }
    
    ${Humberger} {
      background-color: transparent;

      &::before {
        transform: rotate(45deg);
      }

      &::after {
        transform: rotate(-45deg);
      }
    }
  `}

  ${({ hiddenNav }) =>
    !hiddenNav &&
    `
    ${Toggler}:hover ${Humberger}::before,
    ${Toggler}:hover ${Humberger}::after {
      width: 100%;
    }
  `}


${({ hiddenNav }) =>
    !hiddenNav &&
    `
    position: fixed;
    top: 55px;
    padding: 20px 15px;

    ${ContainerUtils} {
      max-width: 1200px;
      margin: auto;
    }
  `}
`;
